export class TreeViewModel {
    public constructor(
        viewName: string,
        index?: number,
        id?: string,
        isEnable?: boolean,
        isIndeterminated?: boolean,
        childrens?: TreeViewModel[],
    ) {
        this.isOpen = false;
        this.viewName = viewName;

        if (index == null) {
            this.index = 0;
        } else {
            this.index = index;
        }

        if (id == null) {
            this.id = "0";
        } else {
            this.id = id;
        }

        if (isEnable == null) {
            this.isEnable = false;
            this.isIndeterminate = false;
        } else {
            this.isEnable = isEnable;
            this.isIndeterminate = false;
        }

        if (childrens == null) {
            this.childrens = undefined;
            this.isIndeterminate = false;
        } else {
            this.childrens = childrens;
            this.isIndeterminate = false;

            var foundedActiveChild = childrens
                .filter(current => current.isEnable == true);

            if (foundedActiveChild.length > 0 && foundedActiveChild.length != childrens.length) {
                this.isIndeterminate = true;
            }
        }
    }

    public index: number;
    public viewName: string;
    public id: string;
    public isEnable: boolean;
    public isIndeterminate: boolean;
    public isOpen: boolean;
    public stateEdit: boolean = false;
    public childrens?: TreeViewModel[];
}


export class TreeViewInputModel {
    constructor(
      inputdata: TreeViewModel[],
      editable: boolean,
      deleteable: boolean,
      translateable: boolean,
      checkable: boolean
    ) {
      this.inputData = inputdata;
      this.editable = editable;
      this.deleteable = deleteable;
      this.checkable = checkable;
      this.translateable = translateable;
    }
  
    public inputData: TreeViewModel[];
  
    public editable: boolean;
    public deleteable: boolean;
    public checkable: boolean;

    public translateable: boolean;
  }
  